"use client";

import { c as _c } from "react/compiler-runtime";
import { useDesktopAnimations } from "@/lib/breakpoints";
import React from "react";
import Image from "next/image";
import { motion } from "framer-motion";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, FreeMode } from "swiper/modules";
import { shopifyTrustedLogos } from "./shopify.data";
import "swiper/css";
import "swiper/css/free-mode";
const ease = [0.17, 0.85, 0.438, 0.99] as const;
interface CrmHeroSwiperProps {
  title?: string;
  className?: string;
}
export default function CrmHeroSwiper(t0) {
  const $ = _c(20);
  const {
    title: t1,
    className: t2
  } = t0;
  const title = t1 === undefined ? "Trusted by Startups and Big Brands" : t1;
  const className = t2 === undefined ? "" : t2;
  const desktopAnimations = useDesktopAnimations();
  let t3;
  if ($[0] !== desktopAnimations) {
    t3 = desktopAnimations ? {
      opacity: 0,
      y: 24
    } : false;
    $[0] = desktopAnimations;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  let t4;
  if ($[2] !== desktopAnimations) {
    t4 = desktopAnimations ? {
      opacity: 1,
      y: 0
    } : undefined;
    $[2] = desktopAnimations;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  let t5;
  if ($[4] !== desktopAnimations) {
    t5 = desktopAnimations ? undefined : {
      opacity: 1,
      y: 0
    };
    $[4] = desktopAnimations;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  let t7;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = {
      once: true
    };
    t7 = {
      duration: 0.7,
      delay: 0.25,
      ease
    };
    $[6] = t6;
    $[7] = t7;
  } else {
    t6 = $[6];
    t7 = $[7];
  }
  const t8 = `w-full max-w-[1290px] mx-auto px-[15px] pb-4 text-center ${className}`;
  let t9;
  if ($[8] !== title) {
    t9 = title && <h2 className="font-poppins mb-10 text-[18px] font-bold text-[#0b1354] md:text-[20px] dark:text-white">{title}</h2>;
    $[8] = title;
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = [Autoplay, FreeMode];
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  let t12;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t11 = {
      delay: 0,
      disableOnInteraction: false,
      pauseOnMouseEnter: false
    };
    t12 = {
      576: {
        slidesPerView: 3,
        spaceBetween: 40
      },
      768: {
        slidesPerView: 4,
        spaceBetween: 50
      },
      992: {
        slidesPerView: 5,
        spaceBetween: 60
      }
    };
    $[11] = t11;
    $[12] = t12;
  } else {
    t11 = $[11];
    t12 = $[12];
  }
  let t13;
  if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <Swiper modules={t10} slidesPerView={2} spaceBetween={30} loop={true} freeMode={true} allowTouchMove={false} speed={4000} autoplay={t11} breakpoints={t12} className="!px-2 [&_.swiper-wrapper]:!ease-linear">{[...shopifyTrustedLogos, ...shopifyTrustedLogos].map(_temp)}</Swiper>;
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  let t14;
  if ($[14] !== t3 || $[15] !== t4 || $[16] !== t5 || $[17] !== t8 || $[18] !== t9) {
    t14 = <motion.div initial={t3} whileInView={t4} animate={t5} viewport={t6} transition={t7} className={t8}>{t9}{t13}</motion.div>;
    $[14] = t3;
    $[15] = t4;
    $[16] = t5;
    $[17] = t8;
    $[18] = t9;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  return t14;
}
function _temp(logo, index) {
  return <SwiperSlide key={`${logo.alt}-${index}`} className="!flex items-center justify-center"><Image src={logo.src} alt={logo.alt} width={240} height={100} loading="lazy" className="h-[60px] w-auto max-w-[180px] object-contain md:h-[90px] md:max-w-[230px]" /></SwiperSlide>;
}